import { createStore, compose, applyMiddleware } from 'redux';
import { sagas } from 'sagas/index';
import { routerMiddleware } from 'react-router-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createHashHistory';
import reduxReset from 'redux-reset';
import ReactGA from 'react-ga';

import rootReducer from 'reducers';

// Create a history of your choosing (we're using a browser history in this case)
export const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const reduxRouterMiddleware = routerMiddleware(history);

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
    key: 'digimail',
    storage: storageSession,
    whitelist: [
        'status_check',
        'sessions',
        'customer',
        'agreement',
        'texts',
        'medias',
        'tags',
        'popup',
        'popup_bankid',
        'government_status',
        'government_list',
        'company',
        'envelopes_inbox',
        'envelopes_archives',
        'envelope',
        'envelope_contents',
        'envelope_content_inline',
        'evenlope_content_document',
        'search_results'
    ]
};

const reducer = persistReducer(persistConfig, rootReducer);

// Enable redux devtools if extension is available in browser
const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
              // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
          })
        : compose;

// Track all redux actions with Google Analytics
// Not used at the moment
const reduxGoogleAnalyticsMiddleWare = store => next => action => {
    // Filter certain actions from GA
    let unwantedFilters = ['@@', 'persist'];

    let showStat = true;
    unwantedFilters.forEach(function(filter) {
        if (String(action.type).indexOf(filter) >= 0) {
            showStat = false;
        }
    });

    if (showStat) {
        ReactGA.event({
            category: 'Digimail K3',
            action: action.type
        });
    }
    next(action);
};

const store = createStore(reducer, composeEnhancers(applyMiddleware(reduxRouterMiddleware, sagaMiddleware), reduxReset()));

export const persistor = persistStore(store, {}, () => {
    console.log('Store rehydrated');
});

sagaMiddleware.run(sagas);

export default store;



// WEBPACK FOOTER //
// ./src/store.js